import React, {Component, Fragment} from 'react';
import { connect } from "react-redux";
import ShoppingCartMobile from "./shoppingCartMobile";
import ShoppingCartDesktop from "./shoppingCartDesktop";
import {toggleBathroomVisualizerOpen} from "../../actions/actionFunctions";
import UnlockCalculations from "./unlockCalculations";
import {setAdvancedQuotingSearchItem} from "../../actions/advancedQuotingFunctions";
import ShoppingCartSureTaxUpdater from "./shoppingCartSureTaxUpdater";
import {toggleShowAssignQuotePopup} from "../../actions/assignPopupFunctions";
import {setWizardAllowSkipDoneSteps} from "../../actions/wizardFunctions";
import {IS_OFFLINE_MODE} from "../../config";

class ShoppingCartView extends Component {

  componentDidMount() {
    if (this.props.bvOpened) {
      this.props.toggleBathroomVisualizerOpen(false);
    }
    if (this.props.advancedQuotingSearchItem) {
      this.props.setAdvancedQuotingSearchItem(null);
    }
    if (this.props.wizardAllowSkipDoneSteps) {
      this.props.setWizardAllowSkipDoneSteps(false);
    }
    if (this.props.fabricatorData.settings.sureTax && !this.props.isPhoneNumberValidated) {
      if (document.kvConfig.isBackend && !IS_OFFLINE_MODE) { //  && !editToken
        this.props.toggleShowAssignQuotePopup(true, "updateTax");
      } else { // regular user popup
        // toggleUserPopup({
        //   userPopupOpened: true
        // })
      }
    }
  }

  render() {
    const {fabricatorData, visualizersLoaded} = this.props;
    if (!visualizersLoaded.length || !fabricatorData.received) {
     return null
    }
    return (
      <Fragment>
        {this.props.windowWidth > 991 ? <ShoppingCartDesktop/> : <ShoppingCartMobile/>}
        <UnlockCalculations/>
        {fabricatorData.settings.sureTax ? <ShoppingCartSureTaxUpdater/> : null}
      </Fragment>
    )
  }
}

const mapStateToProps = (store) => {
  const {isPhoneNumberValidated} = store.userState;
  const {wizardAllowSkipDoneSteps} = store.wizardState;
  return {
    windowWidth: store.serverState.windowWidth,
    visualizersLoaded: store.serverState.visualizersLoaded,
    bvOpened: store.bathroomVisualizerState.bvOpened,
    fabricatorData: store.fabricatorState,
    advancedQuotingSearchItem: store.advancedQuotingState.advancedQuotingSearchItem,
    isPhoneNumberValidated,
    wizardAllowSkipDoneSteps,
  };
};

const mapDispatchToProps = {
  toggleBathroomVisualizerOpen,
  setAdvancedQuotingSearchItem,
  toggleShowAssignQuotePopup,
  setWizardAllowSkipDoneSteps,
}

export default connect(mapStateToProps, mapDispatchToProps)(ShoppingCartView);
